import { render, staticRenderFns } from "./PreloadBtn.vue?vue&type=template&id=08442fe3"
import script from "./PreloadBtn.vue?vue&type=script&lang=js"
export * from "./PreloadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports